export const labels = ['eh', 'attadius', 'credendo', 'coface']

export const PRECISION_FORMATS = { days: 'd. M. YYYY', month: 'M. YYYY', year: 'M. YYYY' }

export const NA_CODES = ['NB', 'NC', 'NG', 'NI', 'NL', 'NN', 'NO', 'NP', 'NQ', 'NR', 'NS', 'NA', 'NM', 'N2']
